import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAlgoliaSearch } from '../../hooks/use-algolia-search.js';
import { createFiltersFromSkus, createFiltersFromQuery } from './utils.js';

/**
 * QueryAlgoliaProducts is a component that mainly wraps the `useAlgoliaSearch` hook.
 * Based on the supplied the props `skus`, `queryString` and `ruleContext`  we map the data for querying Algolia.
 * This component expects a render function as a child which takes the searchResults as an argument.
 */ function QueryAlgoliaProducts({ skus , queryString , ruleContext , algoliaConfig , children  }) {
    /**
   * Prepare options for searching
   * Creates the filters based on the given sku's or the queryString
   * The skus gets priority over the queryString when both are defined.
   */ const searchOptions = React.useMemo(()=>{
        const ruleContexts = typeof ruleContext === 'string' ? [
            ruleContext
        ] : ruleContext;
        const filters = skus.length > 0 ? createFiltersFromSkus(skus) : createFiltersFromQuery(queryString, algoliaConfig.facets);
        return {
            filters,
            ruleContexts
        };
    }, [
        skus,
        ruleContext,
        queryString,
        algoliaConfig
    ]);
    const result = useAlgoliaSearch(algoliaConfig, searchOptions);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children(swcHelpers.objectSpread({}, result, {
        result: result.result
    })));
}

export { QueryAlgoliaProducts };
//# sourceMappingURL=QueryAlgoliaProducts.js.map
